import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export default function AffiliateForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/affiliates/forgot-password`, { email });
      setDone(true);
    } catch {
      // On affiche le succès quand même pour ne pas leak
      setDone(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 to-orange-100 p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold text-stone-800 mb-2">Mot de passe oublié</h2>
        <p className="text-stone-600 mb-6">
          Saisissez votre email, nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        {done ? (
          <div className="space-y-4">
            <div className="p-4 rounded-lg bg-emerald-50 border border-emerald-200 text-sm text-emerald-700">
              Si cet email est associé à un compte affilié, un lien de réinitialisation vient d'être envoyé.
            </div>
            <Link
              to="/affilie/login"
              className="block text-center text-sm text-orange-600 hover:underline"
            >
              ← Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-3 py-2 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 bg-orange-600 hover:bg-orange-500 text-white rounded-lg font-medium transition disabled:opacity-50"
            >
              {submitting ? "Envoi..." : "Envoyer le lien"}
            </button>
            <Link
              to="/affilie/login"
              className="block text-center text-sm text-stone-500 hover:underline"
            >
              ← Retour à la connexion
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}